import React, { useState } from 'react';
import { Switch, Tooltip } from '@amzn/storm-ui';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { ATC_EXTERNAL_TOGGLE } from 'src/commons/constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const ExternalSwitch: React.VFC<{
  isDisabled: boolean;
}> = ({ isDisabled }) => {
  const bundle = usePageHeaderBundle();

  const [toggled, setToggled] = useState<boolean>(
    window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) === 'true',
  );

  const onChange = (toggled: boolean) => {
    if (toggled) {
      window.sessionStorage.setItem(ATC_EXTERNAL_TOGGLE, 'true');
    } else {
      window.sessionStorage.removeItem(ATC_EXTERNAL_TOGGLE);
    }
    setToggled(toggled);
    window.location.reload();
  };

  return (
    <Switch
      id="atc-external-toggle"
      toggled={toggled}
      onChange={onChange}
      label={bundle.getMessage('page-header-external-toggle')}
      switchLabel={bundle.getMessage('page-header-external-toggle')}
      disabled={isDisabled}
      data-ccx-e2e-id="atc-external-toggle"
      {...getTaktAttributes('atc-external-toggle', chromeComponents.HEADER)}
    />
  );
};

export const ExternalToggle: React.VFC<{
  isDisabled: boolean;
}> = ({ isDisabled }) => {
  const bundle = usePageHeaderBundle();
  if (!isDisabled) return <ExternalSwitch isDisabled={isDisabled} />;

  return (
    <Tooltip
      trigger={
        <span>
          <ExternalSwitch isDisabled={isDisabled} />
        </span>
      }
      message={bundle.getMessage(
        'page-header-external-toggle-internal-only-tooltip',
      )}
      position="bottom"
      withCloseButton={false}
    />
  );
};
